export const baseURLbucket = process.env.REACT_APP_BUCKET_URL

export const baseUrlAPIOffline = process.env.REACT_APP_END_POINT_API_OFFLINE

export const baseUrlAPIGql = process.env.REACT_APP_END_POINT_API_GQL
